import {
  messageId,
  PropertyMeta,
  ValueObjectMetaString,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.string().max(10000);
const savedMinimalSchema = z.string().max(10000);
const schema = z.string().min(1).max(10000);
const savedSchema = z.string().min(1).max(10000);
const jsonSchema = z.string();
/**
 * 変更理由内容(値オブジェクト)のメタデータ。
 *
 *  */
export const changeReasonContentMeta = new ValueObjectMetaString(
  "ChangeReasonContent",
  "\u5909\u66F4\u7406\u7531\u5185\u5BB9",
  messageId("lbl.\u5909\u66F4\u7406\u7531\u5185\u5BB9"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
